export default __webpack_public_path__ + "static/media/amb-color.9ae618e2.svg";